import { render, staticRenderFns } from "./ButtonTiles.vue?vue&type=template&id=51cc93b6&scoped=true"
import script from "./ButtonTiles.vue?vue&type=script&lang=js"
export * from "./ButtonTiles.vue?vue&type=script&lang=js"
import style0 from "./ButtonTiles.vue?vue&type=style&index=0&id=51cc93b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cc93b6",
  null
  
)

export default component.exports